import tools from 'utils/tools';

const ProtectedRoute = tools.lazyWithRetry(() =>
  import('layouts/RouteAccessModifiers'),
);
const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const ProfileEdit = tools.lazyWithRetry(() =>
  import('components/pages/Profile/ProfileEdit'),
);
const ProfileIndex = tools.lazyWithRetry(() =>
  import('components/pages/Profile/ProfileIndex'),
);
const ProfileSetting = tools.lazyWithRetry(() =>
  import('components/pages/Profile/ProfileSetting'),
);

const profileRoutes = [
  {
    path: '/profile',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <ProfileIndex /> },
      { path: 'edit', element: <ProfileEdit /> },
      { path: 'setting', element: <ProfileSetting /> },
    ],
  },
];

export default profileRoutes;
